import Model from 'flarum/common/Model';
import transformDate from '../utils/transformDate';
export default class PickemEvent extends Model {
  weekId = Model.attribute('weekId');
  homeTeamId = Model.attribute('homeTeamId');
  awayTeamId = Model.attribute('awayTeamId');
  matchDate = Model.attribute('matchDate', transformDate);
  cutoffDate = Model.attribute('cutoffDate', transformDate);
  allowDraw = Model.attribute('allowDraw');
  status = Model.attribute('status');
  homeScore = Model.attribute('homeScore');
  awayScore = Model.attribute('awayScore');
  result = Model.attribute('result');
  canPick = Model.attribute('canPick');
  week = Model.hasOne('week');
  homeTeam = Model.hasOne('homeTeam');
  awayTeam = Model.hasOne('awayTeam');
}
flarum.reg.add('huseyinfiliz-pickem', 'common/models/Event', PickemEvent);